import React from 'react';
import { useTheme } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Image from 'next/image';
import { CmsHtmlContent } from '@/components/CmsHtmlContent';
import analytics from '@/services/analytics';
import { CmsMarketingCard } from '@/services/cms/models/CmsMarketingCard';
import { CardDescription } from './components/CardDescription';
import { CardTitle } from './components/CardTitle';

export const MarketingCard = ({ icon, title, content }: CmsMarketingCard) => {
    const theme = useTheme();
    return (
        <Card
            elevation={0}
            onClick={() => {
                analytics.plugins.interactions.trackInteraction({
                    source: 'Marketing card',
                    action: 'click',
                    label: title,
                });
            }}
            sx={{
                padding: 0,
                margin: 0,
                '&:last-child': {
                    padding: 0,
                },
            }}
        >
            {icon?.link ? <Image src={icon.link} alt={icon.name} height={35} width={35} /> : null}
            <CardContent
                sx={{
                    padding: 0,
                    margin: 0,
                    '&:last-child': {
                        padding: 0,
                    },
                }}
            >
                <CardTitle sx={{ padding: 0, margin: 0, fontSize: 14, fontWeight: 700, lineHeight: 1 }}>{title}</CardTitle>
                <CardDescription
                    sx={{
                        padding: 0,
                        fontSize: 12,
                        '& p:first-of-type': { mt: 0.5 },
                        '& a:link': { color: theme.colors.secondary.main },
                        '& a:visited': { color: theme.colors.secondary.main },
                    }}
                >
                    <CmsHtmlContent html={content} plain={true} />
                </CardDescription>
            </CardContent>
        </Card>
    );
};
